export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';

export const RESET = 'RESET';

export const SIGN_IN_RESET = 'SIGN_IN_RESET';
export const SIGN_IN_OK = 'SIGN_IN_OK';
export const SIGN_IN_FAILURE = 'SIGN_IN_FAILURE';

export const FETCH_LEDMODULES = 'FETCH_LEDMODULES';
export const FETCH_LEDMODULE = 'FETCH_LEDMODULE';
export const RESET_LEDMODULES = 'RESET_LEDMODULES';

export const FETCH_ORIGINAL_LEDMODULE = 'FETCH_ORIGINAL_LEDMODULE';

export const FETCH_LEDMODULE_PROPERTIES = 'FETCH_LEDMODULE_PROPERTIES';
export const FETCH_LEDMODULE_FEATURES = 'FETCH_LEDMODULE_FEATURES';

export const CREATE_LEDMODULE = 'CREATE_LEDMODULE';
export const UPDATE_LEDMODULE = 'UPDATE_LEDMODULE';
export const DELETE_LEDMODULE = 'DELETE_LEDMODULE';
export const RESET_LEDMODULE = 'RESET_LEDMODULE';

export const DOWNLOAD_LEDMODULE = 'DOWNLOAD_LEDMODULE';

export const COPY_LEDMODULE = 'COPY_LEDMODULE';
export const SET_TEMPORARY_LEDMODULE = 'SET_TEMPORARY_LEDMODULE';

export const ERROR_ADD = 'ERROR_ADD';
export const ERROR_REMOVE = 'ERROR_REMOVE';
export const NOT_FOUND_ERROR_REMOVE = 'NOT_FOUND_ERROR_REMOVE';


export const ISSUES_ADD = 'ISSUES_ADD';